import type { RefObject } from "react";
import { createContext, useContext } from "react";

import type { ScrollGroupItem } from "../ScrollGroup/context";

export const StickyGridContext = createContext<StickyGridContextType | null>(
  null,
);

export type StickyGridContextType = {
  templateColumns: string;
  gap?: string;
  isAtMinX: boolean;
  isAtMaxX: boolean;
  setIsAtMaxX: (value: boolean) => void;
  setIsAtMinX: (value: boolean) => void;
  scrollTo: (offset: {
    top?: number;
    left?: number;
    behavior?: "smooth";
  }) => void;
  scrollGroupItemsRef: RefObject<ScrollGroupItem[]>;
};

export function useStickyGrid() {
  const value = useContext(StickyGridContext);
  if (!value) {
    throw new Error("Please wrap this component in <StickyGrid />");
  }
  return value;
}
